const styles = theme => ({
  card: {
    width: 300,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
})

export default styles
